
export default function Pricing() {
  return (
    <section 
      id="pricing" 
      className="py-20 bg-cover bg-center bg-no-repeat relative"
      style={{
        backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.95)), url('https://public.readdy.ai/ai/img_res/2122f8bd04835c9b3a13ff6d71e17833.jpg')`
      }}
    >
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
            会社概要
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            私たちの会社について詳しくご紹介いたします
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto">
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-lg p-8">
            <div className="space-y-8">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="md:col-span-1">
                  <h3 className="text-lg font-medium text-gray-600 mb-2">会社名</h3>
                </div>
                <div className="md:col-span-2">
                  <p className="text-lg text-gray-900">株式会社アシスト</p>
                </div>
              </div>

              <div className="border-t border-gray-200 pt-6">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="md:col-span-1">
                    <h3 className="text-lg font-medium text-gray-600 mb-2">所在地</h3>
                  </div>
                  <div className="md:col-span-2">
                    <p className="text-lg text-gray-900">〒162-0822 東京都新宿区下宮比町2-28 飯田橋ハイタウン1033号</p>
                  </div>
                </div>
              </div>

              <div className="border-t border-gray-200 pt-6">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="md:col-span-1">
                    <h3 className="text-lg font-medium text-gray-600 mb-2">電話番号</h3>
                  </div>
                  <div className="md:col-span-2">
                    <p className="text-lg text-gray-900">090-4434-4518</p>
                  </div>
                </div>
              </div>

              <div className="border-t border-gray-200 pt-6">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="md:col-span-1">
                    <h3 className="text-lg font-medium text-gray-600 mb-2">営業時間</h3>
                  </div>
                  <div className="md:col-span-2">
                    <p className="text-lg text-gray-900">平日　9:00〜18:00</p>
                  </div>
                </div>
              </div>

              <div className="border-t border-gray-200 pt-6">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div className="md:col-span-1">
                    <h3 className="text-lg font-medium text-gray-600 mb-2">定休日</h3>
                  </div>
                  <div className="md:col-span-2">
                    <p className="text-lg text-gray-900">土・日・祝</p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* コーポレートサイトボタン */}
            <div className="mt-12 text-center">
              <a 
                href="https://assi-ltd.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-[#2d88ba] text-white px-8 py-3 rounded-lg hover:bg-[#1a7ea] transition-colors cursor-pointer text-lg font-medium whitespace-nowrap shadow-lg inline-flex items-center gap-2"
              >
                <i className="ri-external-link-line text-lg"></i>
                コーポレートサイトはこちら
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
